import React, { useState } from "react";
import styles from "./StaffOrderHistory.module.css";
import StepsComponent from "../../../../../../components/StepsComponent/StepsComponent";
import SubmitButton from "../../../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../../../components/textComponent/TextComponent";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";

const OrderHistoryComponent = () => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Order ID",
      dataIndex: "OrderID",
      key: "OrderID",
    },

    {
      title: "Order Date",
      dataIndex: "OrderDate",
      key: "OrderDate",
    },

    {
      title: "Order by",
      key: "Order by",
      dataIndex: "Orderby",
    },
    {
      title: "Fulfillment Status",
      key: "FulfillmentStatus",
      dataIndex: "FulfillmentStatus",
    },
    {
      title: "Due Date",
      key: "Due Date",
      dataIndex: "DueDate",
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const data = [
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      DueDate: "Aug 13, 2025 ",

      LotNo: `#123`,
      Orderby: "Alex Buckmaster",
      LotUsed: "30 kg",
      FulfillmentStatus: "Delivered",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/StaffReciepeProductJourney")}
        />
      ),
    },
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      DueDate: "Aug 13, 2025 ",

      LotNo: `#123`,
      Orderby: "Alex Buckmaster",
      FulfillmentStatus: "Delivered",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/StaffReciepeProductJourney")}
        />
      ),
    },
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      LotNo: `#123`,
      DueDate: "Aug 13, 2025 ",

      Orderby: "Alex Buckmaster",
      FulfillmentStatus: "Delivered",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/StaffReciepeProductJourney")}
        />
      ),
    },
    {
      OrderID: "153534",
      OrderDate: "Aug 13, 2025 ",
      DueDate: "Aug 13, 2025 ",

      Quantity: "100.00",
      LotNo: `#123`,
      Orderby: "Alex Buckmaster",
      FulfillmentStatus: "Delivered",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/StaffReciepeProductJourney")}
        />
      ),
    },
    {
      OrderID: "153534",
      DueDate: "Aug 13, 2025 ",

      OrderDate: "Aug 13, 2025 ",
      LotNo: `#123`,
      Orderby: "Alex Buckmaster",
      FulfillmentStatus: "Delivered",
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/StaffReciepeProductJourney")}
        />
      ),
    },
  ];

  return (
    <div className={styles.mainCont}>
      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="No"
        />
      </div>
    </div>
  );
};

export default OrderHistoryComponent;
